import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import routesConfig from "./routesConfig";
import Layout from "./components/layout";

import Login from "./pages/Login";
import Register from "./pages/Register";
import Unauthorized from "./pages/Unauthorized";
import Dashboard from "./pages/Dashboard";
import Admin from "./pages/AdminDashboard";
import AddNewUser from "./pages/addNewUser";
import AddIncomingTab from "./pages/IncomingTab";
import IncomingPreview from "./pages/IncomingPreview";
import AddFreeNowInfo from "./pages/addFreenow";
import EditFreeNowInfo from "./pages/freenowInfo";
import adminUsers from "./pages/admin/users"

import adminDriverRaport from "./pages/admin/driverRaport"
import adminDriversDebts from "./pages/admin/driversDebts"
import DriverDebtDetails from "./pages/admin/DriverDebtDetails"; // імпортуємо сторінку деталей
import DriverExtraFunds from "./pages/admin/extraFunds";
import DriverExtraFundsEdit from "./pages/admin/extraFundsEdit";
import ExtraFundsDefaultValues from "./pages/admin/extraFundsDefaultValues";
import CashStats from "./pages/admin/cashStats";
import Instructions from "./pages/instructions";
import editSourceData from "./pages/admin/editSourceData";
import weeklyStats from './pages/admin/weeklyStats';
import WeekStatistics from './pages/admin/weekStatistics';
import UserSettings from "./pages/userSettings";
import adminRaports from "./pages/admin/adminReports";
import siteSettings from "./pages/admin/settings";
import UserDashboard from "./pages/user/userDashboard";
import UserRaport from "./pages/user/userReportDetails";

import CookieConsent from "./components/CookieConsent";
import PrivacyPolicy from "./pages/privacyPolicy";
import MainPage from "./pages/mainpage"
import AdminMessageForm from "./pages/admin/messages/AdminMessageForm";
import AdminMessagesList from "./pages/admin/messages/AdminMessagesList";
import UserMessages from "./pages/user/userMessages";
import DriverUploadInvoicePage from "./pages/user/DriverUploadInvoicePage";
import DriverMyInvoicesPage from "./pages/user/DriverMyInvoicesPage";
import AdminReportsTable from "./pages/admin/DriverReportsTable"
import AdminReportView from "./pages/admin/AdminReportView"
import MonthlyReports from "./pages/admin/monthlyReports"
import GenerateInvoice from "./pages/admin/generateInvoice"
import MonthSummary from "./pages/admin/monthSummary"
import InvoiceConstructor from "./pages/admin/InvoiceConstructor"
import FleetList from "./pages/admin/fleet/FleetList";
import FleetVehicleForm from "./pages/admin/fleet/FleetVehicleForm";
import FleetVehicleUsageLogs from "./pages/admin/fleet/FleetVehicleUsageLogs";
import VehicleUsageConfirmModal from "./components/VehicleUsageConfirmModal";
import DataImport from "./pages/admin/DataImport";
import ImportTemplates from "./pages/admin/ImportTemplates";
import KsefPage from "./pages/admin/KsefPage";
import DriverInvoicesPage from "./pages/admin/DriverInvoicesPage";
import DriverInvoiceUploadPage from "./pages/admin/DriverInvoiceUploadPage";
import InvoicesVatUpdate1206 from "./pages/admin/updates/InvoicesVatUpdate1206";
import KsefUpdate1207 from "./pages/admin/updates/KsefUpdate1207";
import KsefUpdate0308 from "./pages/admin/updates/KsefUpdate0308";
import Update1008 from "./pages/admin/updates/Update1008";
import Update050 from "./pages/admin/updates/Update050";
import Update052 from "./pages/admin/updates/Update052";
import FleetUsageUpdate2007 from "./pages/admin/updates/FleetUsageUpdate2007";
import "./i18n";

const componentMap = {
  Dashboard,
  Admin,
  AddNewUser,
  AddIncomingTab,
  IncomingPreview,
  AddFreeNowInfo,
  EditFreeNowInfo,
  adminUsers,
  adminDriverRaport,
  adminDriversDebts,
  DriverDebtDetails,
  DriverExtraFunds,
  DriverExtraFundsEdit,
  ExtraFundsDefaultValues,
  CashStats,
  Instructions,
  editSourceData,
  weeklyStats,
  WeekStatistics,
  UserSettings,
  adminRaports,
  siteSettings,
  UserDashboard,
  UserRaport,
  AdminMessageForm,
  AdminMessagesList,
  UserMessages,
  DriverUploadInvoicePage,
  DriverMyInvoicesPage,
  AdminReportsTable,
  AdminReportView,
  monthlyReports: MonthlyReports,
  generateInvoice: GenerateInvoice,
  monthSummary: MonthSummary,
  invoiceConstructor: InvoiceConstructor,
  FleetList,
  FleetVehicleForm,
  FleetVehicleUsageLogs,
  DataImport,
  ImportTemplates,
  KsefPage,
  DriverInvoicesPage,
  DriverInvoiceUploadPage,
  InvoicesVatUpdate1206,
  KsefUpdate1207,
  KsefUpdate0308,
  Update1008,
  Update050,
  Update052,
  FleetUsageUpdate2007
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Публічні маршрути */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/unauthorized" element={<Unauthorized />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/home" element={<MainPage />} />



          {/* Дефолтний маршрут */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Dashboard />} />
            {routesConfig.map(({ path, component, roles }) => {
              const Component = componentMap[component];
              return (
                <Route
                  key={path}
                  path={path}
                  element={
                    <ProtectedRoute allowedRoles={roles}>
                      <Component />
                    </ProtectedRoute>
                  }
                />
              );
            })}
          </Route>

        </Routes>
        <CookieConsent />
        <VehicleUsageConfirmModal />

      </Router>
    </AuthProvider>
  );
}

export default App;
